module.exports = "/images/baby-or-adoption.png?2e8ebbe8fe8abc85393ed7f515be48e4";